
export const UK_ROUTES_NEW = {
    home: "/",
    howItWorks: "/#how-it-works",
    whyTaxzap: "/#why-taxzap",
    faqs: "/faqs",
    contact: "/#contact",
    pricing: "/pricing",
    resources: "/resources",
    employmentTaxCalc: "/tax-calculator/employment",
    tcs: "/terms-and-conditions",
    privacyPolicy: "/privacy-policy",
    engagement: "/terms-of-engagement",
    constructionwWorkers: "/construction-worker",
    landlord: "/landlord",
    deliveryDrivers: "/delivery-drivers",
};
